import React, { useState } from "react";
import SiteNav from "../components/SiteNav";
import Hero from "../components/Hero";
import About from "../components/About";
import Pricing from "../components/Pricing";
import Portfolio from "../components/Portfolio";
import JoinCompany from "../components/JoinCompany";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Home() {
  // Nav, Hero, Footer "Book Now" all scroll to #pricing where users can pick a Stripe-direct package
  const scrollToPricing = () => scrollToId("pricing");
  const scrollToJoin = () => scrollToId("join");

  return (
    <div className="relative min-h-screen bg-[#050505] text-white galaxy-bg" data-testid="home-page">
      <SiteNav onBookNow={scrollToPricing} />
      <main>
        <Hero onBookNow={scrollToPricing} onJoin={scrollToJoin} />
        <About />
        <Pricing />
        <Portfolio />
        <JoinCompany />
        <Contact />
        <Footer onBookNow={scrollToPricing} />
      </main>
    </div>
  );
}
